import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'export',
  props: {
    text: null,
    hasIcon: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    text?: string
    hasIcon?: boolean
}



return { __sfc: true,props }
}

})